import React, { useEffect } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  IconButton,
} from "@mui/material";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import LocalPostOfficeIcon from "@mui/icons-material/LocalPostOffice";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const ContactUS = () => {
  useEffect(() => {
    document.title = "Contact US - MS Digital Hub";
  }, []);

  const address =
    "Center for Digital Humanities,Liberal Arts Building, Room 348 1999 Pearl St., Hattiesburg, MS 39401";

  const EMAIL = "dh@usm.edu";
  const PHONE = "601.266.4558";

  const contactLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Mississippi Digital Humanities Hub",
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "customer support",
        email: EMAIL,
        telephone: PHONE,
      },
    ],
    address: {
      "@type": "PostalAddress",
      streetAddress: "1999 Pearl St.",
      addressLocality: "Hattiesburg",
      addressRegion: "MS",
      postalCode: "39401",
      addressCountry: "US",
    },
  };

  return (
    <Box
      sx={{
        width: "auto",
        padding: "0px 20px",
        margin: "0px auto",
        padding: { xs: "20px", sm: "30px", md: "1px 80px" },
        border: "none",
        backgroundColor: "#ffffff",
        borderRadius: "8px",
      }}
    >
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(contactLd) }}
      />
      <Box
        sx={{
          position: "absolute",
          left: -99999,
          top: "auto",
          width: 1,
          height: 1,
          overflow: "hidden",
        }}
        aria-hidden="true"
      >
        Contact email: {EMAIL} | Phone: {PHONE}
      </Box>
      <Typography
        variant="h4"
        sx={{ marginBottom: "30px", paddingLeft: "10px", textAlign: "center" }}
      >
        Contact
      </Typography>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          height: "auto",
          overflow: "hidden",
          flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" },
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <Box mt={0}>
            <IconButton>
              <CorporateFareIcon fontSize="large" color="primary" />
            </IconButton>
            <Typography variant="h6" sx={{ fontWeight: "medium" }}>
              Primary Contact
            </Typography>
            <List>
              <ListItem disableGutters>
                <ListItemText primary="Mississippi Digital Humanities Hub" />
              </ListItem>
            </List>
            <Divider />
          </Box>
          <Box mt={0}>
            <IconButton>
              <EmailIcon fontSize="large" color="primary" />
            </IconButton>

            <Typography variant="h6" sx={{ fontWeight: "medium" }}>
              Email
            </Typography>
            <List>
              <ListItem disableGutters>
                <ListItemText
                  primary={
                    <a
                      href={`mailto:${EMAIL}`}
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      {EMAIL}
                    </a>
                  }
                />
              </ListItem>
            </List>
            <Divider />
          </Box>
          <Box mt={0}>
            <IconButton>
              <PhoneIphoneIcon fontSize="large" color="primary" />
            </IconButton>
            <Typography variant="h6" sx={{ fontWeight: "medium" }}>
              Phone
            </Typography>
            <List>
              <ListItem disableGutters>
                <ListItemText
                  primary={
                    <a
                      href={`tel:${PHONE.replace(/[^\d+]/g, "")}`}
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      {PHONE}
                    </a>
                  }
                />
              </ListItem>
            </List>
            <Divider />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "column",
                md: "row",
                lg: "row",
              },
              gap: { xs: "20px", sm: "20px", md: "50px", lg: "50px" },
            }}
          >
            <Box
              mt={2}
              sx={{ flex: 1, backgroundColor: "#f5f5f5", borderRadius: "10px" }}
            >
              <IconButton>
                <LocalPostOfficeIcon fontSize="large" color="primary" />
              </IconButton>

              <Typography variant="h6" sx={{ fontWeight: "medium" }}>
                Mailing Address
              </Typography>
              <List sx={{ alignItems: "center" }}>
                <ListItem disableGutters>
                  <ListItemText
                    sx={{ textAlign: "center" }}
                    primary="Mississippi Digital Humanities Hub"
                  />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemText
                    sx={{ textAlign: "center" }}
                    primary="118 College Dr. #5037"
                  />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemText
                    sx={{ textAlign: "center" }}
                    primary="Hattiesburg, MS 39406"
                  />
                </ListItem>
              </List>
            </Box>
            <Box
              mt={2}
              sx={{ flex: 1, backgroundColor: "#f5f5f5", borderRadius: "10px" }}
            >
              <IconButton>
                <LocationOnIcon fontSize="large" color="primary" />
              </IconButton>
              <Typography variant="h6" sx={{ fontWeight: "medium" }}>
                Physical Address
              </Typography>
              <List>
                <ListItem disableGutters>
                  <ListItemText
                    p
                    sx={{ textAlign: "center" }}
                    primary="Center for Digital Humanities"
                  />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemText
                    sx={{ textAlign: "center" }}
                    primary="Liberal Arts Building, Room 348"
                  />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemText
                    sx={{ textAlign: "center" }}
                    primary="1999 Pearl St., Hattiesburg, MS 39401"
                  />
                </ListItem>
              </List>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: { xs: "20px", sm: "20px" },
          }}
        >
          <iframe
            title="google map"
            width="100%"
            height="100%"
            style={{ border: 0, borderRadius: "0px" }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyACjuPweMBPZtec5T52uO42s74j2ZIHfjA&q=${encodeURIComponent(address)}`}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ContactUS;
